<template>
  <div class="device">
    <div style="width: 100%;height: 15%;"  @click="cancle()">
    <div class="select">
      <el-form ref="form" label-position="right">
          <el-form-item><el-input v-model="powerBoxIdOrPowerBankId" placeholder="设备编号/小宝编号" style="width:200px" clearable></el-input></el-form-item>
          <el-form-item>
            <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getDeviceInfo">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    </div>
    <div class="deviceDetail" style="background-color: #EEEEEE;" v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"
                 element-loading-background="rgba(0.8, 0, 0, 0.3)">
      <div style="height: 20%;" >
        <div class="erweima">
          <vue-qr :margin="0" :auto-color="true" :dot-scale="1" :text="erweimaSrc" :size="erweimaSrcSize" :logoCornerRadius="1"></vue-qr>
        </div>
        <div class="deviceState">
          <table style="text-align: left; float: left">
            <tr style="height: 35px;">
              <td><span class="black" style="font-size: 0.4rem">设备编号:</span></td>
              <td><span class="chengshe" tyle="font-size: 0.4rem">{{ deviceId }}</span></td>
            </tr>
            <tr>
              <td><span class="black" tyle="font-size: 0.4rem">设备状态:</span></td>
              <td><span class="chengshe" tyle="font-size: 0.4rem">{{ deviceState }}</span></td>
            </tr>
          </table>
        </div>
        <div class="operationDevice" :model="choice">
          <div class="elButton">
            <el-button class="qiangtan" @click="forceEject()">强制弹出</el-button>
            <el-button class="allEject" @click="allEjectDevice()">全部弹出</el-button>
            <el-button class="restart" @click="restartDevice()">重启设备</el-button>
          </div>
          <span class="xuanzhong">已选中：</span>
          <span class="slot">{{ choice }}口</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="deviceInfo" style="width: 100%;height: 70%;" >
        <div class="sixDevice" id="sixDevice" style="width: 100%;height: 100%;">
          <div id="sixOne" @click="clickSixOne()" style="width: 8%; height: 50%; border-radius: 5px;
      background-color: #FFFFFF; margin-left: 20%; margin-top:3%; float: left;" :model="one">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ one }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img1" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank1">{{ bank1 }}</span></div>
            <div><toggle-switch :markToggled="bank1SlotDestroyStatus" :powerBoxId="powerBoxId" :powerSlot="one" /></div>
          </div>
          <div id="sixTwo" @click="clickSixTwo()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;
      margin-left: 2.5%; margin-top:3%; float: left;" :model="two">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ two }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img2" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank2">{{ bank2 }}</span></div>
            <div><toggle-switch :markToggled="bank2SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="two" /></div>
          </div>
          <div id="sixThree" @click="clickSixThree()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;
      margin-left: 2.5%; margin-top:3%; float: left;" :model="three">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ three }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img3" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank3">{{ bank3 }}</span></div>
            <div><toggle-switch :markToggled="bank3SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="three" /></div>
          </div>
          <div id="sixFour" @click="clickSixFour()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;
      margin-left: 2.5%; margin-top:3%; float: left;" :model="four">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ four }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img4" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank4">{{ bank4 }}</span></div>
            <div><toggle-switch :markToggled="bank4SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="four" /></div>
          </div>
          <div id="sixFive" @click="clickSixFive()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;
      margin-left: 2.5%; margin-top:3%; float: left;" :model="five">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ five }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img5" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank5">{{ bank5 }}</span></div>
            <div><toggle-switch :markToggled="bank5SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="five" /></div>
          </div>
          <div id="sixSix" @click="clickSixSix()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;
      margin-left: 2.5%;margin-top:3%; float: left;" :model="six">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ six }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img6" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank6">{{ bank6 }}</span></div>
            <div><toggle-switch :markToggled="bank6SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="six" /></div>
          </div>
        </div>
        <div class="eightDevice" id="eightDevice" style="width: 100%;height: 100%;">
          <div id="one" @click="clickOne()" style="width: 8%; height: 50%; border-radius: 5px;
      background-color: #FFFFFF; margin-left: 10%; margin-top:3%; float: left;" :model="one">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ one }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img1" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank1">{{ bank1 }}</span></div>
            <div><toggle-switch :markToggled="bank1SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="one" /></div>
          </div>
          <div id="two" @click="clickTwo()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;
      margin-left: 2.5%; margin-top:3%; float: left;" :model="two">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ two }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img2" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank2">{{ bank2 }}</span></div>
            <div><toggle-switch :markToggled="bank2SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="two" /></div>
          </div>
          <div id="three" @click="clickThree()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;
      margin-left: 2.5%; margin-top:3%; float: left;" :model="three">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ three }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img3" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank3">{{ bank3 }}</span></div>
            <div><toggle-switch :markToggled="bank3SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="three" /></div>
          </div>
          <div id="four" @click="clickFour()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;
      margin-left: 2.5%; margin-top:3%; float: left;" :model="four">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ four }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img4" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank4">{{ bank4 }}</span></div>
            <div><toggle-switch :markToggled="bank4SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="four" /></div>
          </div>
          <div id="five" @click="clickFive()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;
      margin-left: 2.5%; margin-top:3%; float: left;" :model="five">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ five }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img5" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank5">{{ bank5 }}</span></div>
            <div><toggle-switch :markToggled="bank5SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="five" /></div>
          </div>
          <div id="six" @click="clickSix()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;
      margin-left: 2.5%;margin-top:3%; float: left;" :model="six">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ six }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img6" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank6">{{ bank6 }}</span></div>
            <div><toggle-switch :markToggled="bank6SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="six" /></div>
          </div>
          <div id="seven" @click="clickSeven()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;
       margin-left: 2.5%; margin-top:3%; float: left;" :model="seven">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ seven }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img7" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank7">{{ bank7 }}</span></div>
            <div><toggle-switch :markToggled="bank7SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="seven" /></div>
          </div>
          <div id="eight" @click="clickEight()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;
      margin-left: 2.5%; margin-top:3%; float: left;" :model="eight">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ eight }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img8" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank8">{{ bank8 }}</span></div>
            <div><toggle-switch :markToggled="bank8SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="eight" /></div>
          </div>
        </div>
        <div class="nineDevice" id="nineDevice" style="width: 100%;height: 100%;">
          <div id="one"   @click="clickOne()"   style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;margin-left: 2.5%; margin-top:3%; float: left;" :model="one">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ one }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img1" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank1">{{ bank1 }}</span></div>
            <div><toggle-switch :markToggled="bank1SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="one" /></div>
          </div>
          <div id="two"   @click="clickTwo()"   style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;margin-left: 2.5%; margin-top:3%; float: left;" :model="two">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ two }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img2" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank2">{{ bank2 }}</span></div>
            <div><toggle-switch :markToggled="bank2SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="two" /></div>
          </div>
          <div id="three" @click="clickThree()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;margin-left: 2.5%; margin-top:3%; float: left;" :model="three">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ three }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img3" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank3">{{ bank3 }}</span></div>
            <div><toggle-switch :markToggled="bank3SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="three" /></div>
          </div>
          <div id="four"  @click="clickFour()"  style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;margin-left: 2.5%; margin-top:3%; float: left;" :model="four">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ four }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img4" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank4">{{ bank4 }}</span></div>
            <div><toggle-switch :markToggled="bank4SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="four" /></div>
          </div>
          <div id="five"  @click="clickFive()"  style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;margin-left: 2.5%; margin-top:3%; float: left;" :model="five">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ five }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img5" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank5">{{ bank5 }}</span></div>
            <div><toggle-switch :markToggled="bank5SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="five" /></div>
          </div>
          <div id="six"   @click="clickSix()"   style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;margin-left: 2.5%; margin-top:3%; float: left;" :model="six">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ six }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img6" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank6">{{ bank6 }}</span></div>
            <div><toggle-switch :markToggled="bank6SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="six" /></div>
          </div>
          <div id="seven" @click="clickSeven()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;margin-left: 2.5%; margin-top:3%; float: left;" :model="seven">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ seven }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img7" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank7">{{ bank7 }}</span></div>
            <div><toggle-switch :markToggled="bank7SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="seven" /></div>
          </div>
          <div id="eight" @click="clickEight()" style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;margin-left: 2.5%; margin-top:3%; float: left;" :model="eight">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ eight }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img8" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank8">{{ bank8 }}</span></div>
            <div><toggle-switch :markToggled="bank8SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="eight" /></div>
          </div>
          <div id="nine"  @click="clickNine()"  style="width: 8%; height: 50%; border-radius: 5px; background-color: #FFFFFF;margin-left: 2.5%; margin-top:3%; float: left;" :model="nine">
            <div style="margin-top: 20%; height: 10%;">
              <span style="font-size: 0.6rem; color: #666666; line-height: 50%;">{{ nine }}口</span>
            </div>
            <el-divider></el-divider>
            <div class="image" style="width: 100%; height: 25%;">
              <img :src="img9" alt="" sstyle="width: 80%; height: 80%"/>
            </div>
            <div><span style="font-size: 0.25rem" :model="bank9">{{ bank9 }}</span></div>
            <div><toggle-switch :markToggled="bank9SlotDestroyStatus" :powerBoxId="powerBoxId" :powerSlot="nine" /></div>
          </div>
        </div>
        <div class="twelveDevice" id="twelveDevice" style="width: 100%;height: 100%;">
          <div class="line1" style="width: 100%;height: 20%;margin-top: 1%;">
            <div id="twelveOne" @click="clickTwelveOne()" style="width: 20%; height: 100%; border-radius: 5px;margin-left: 20%;background-color: #FFFFFF; float: left;" :model="one">
              <div style="width: 30%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ one }}口</span>
                <toggle-switch :markToggled="bank1SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="one" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 80%; float: right; margin-right: 4%;margin-top: 6%">
                <img :src="img1" alt="" sstyle="width: 100%; height: 100%;"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank1">{{bank1}}</span></div>
              </div>
            </div>
            <div id="twelveTwo" @click="clickTwelveTwo()" style="width: 20%; height: 100%; border-radius: 5px;margin-left: 5%;background-color: #FFFFFF;float: left;" :model="two">
              <div style="width: 30%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ two }}口</span>
                <toggle-switch :markToggled="bank2SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="two" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img2" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank2">{{ bank2 }}</span></div>
              </div>
            </div>
            <div id="twelveThree" @click="clickTwelveThree()" style="width: 20%; height: 100%; border-radius: 5px;margin-left: 5%;background-color: #FFFFFF; float: left;" :model="three">
              <div style="width: 30%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ three }}口</span>
                <toggle-switch :markToggled="bank3SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="three" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img3" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank3">{{ bank3 }}</span></div>
              </div>
            </div>
          </div>
          <div class="line2" style="width: 100%;height: 20%;margin-top: 1%">
            <div id="twelveFour" @click="clickTwelveFour()" style="width: 20%; height: 100%; border-radius: 5px;margin-left: 20%;background-color: #FFFFFF; float: left;" :model="four">
              <div style="width: 30%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ four }}口</span>
                <toggle-switch :markToggled="bank4SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="four" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img4" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank4">{{ bank4 }}</span></div>
              </div>
            </div>
            <div id="twelveFive" @click="clickTwelveFive()" style="width: 20%; height: 100%; border-radius: 5px; margin-left: 5%;background-color: #FFFFFF;  float: left;" :model="five">
              <div style="width: 30%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ five }}口</span>
                <toggle-switch :markToggled="bank5SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="five" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img5" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank5">{{ bank5 }}</span></div>
              </div>
            </div>
            <div id="twelveSix" @click="clickTwelveSix()" style="width: 20%; height: 100%; border-radius: 5px;margin-left: 5%;background-color: #FFFFFF;  float: left;" :model="six">
              <div style="width: 30%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ six }}口</span>
                <toggle-switch :markToggled="bank6SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="six" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img6" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank6">{{ bank6 }}</span></div>
              </div>
            </div>
          </div>
          <div class="line3" style="width: 100%;height: 20%;margin-top: 1%">
            <div id="twelveSeven" @click="clickTwelveSeven()" style="width: 20%; height: 100%; border-radius: 5px; margin-left: 20%;background-color: #FFFFFF;float: left;" :model="seven">
              <div style="width: 30%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ seven }}口</span>
                <toggle-switch :markToggled="bank7SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="seven" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img7" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank7">{{ bank7 }}</span></div>
              </div>
            </div>
            <div id="twelveEight" @click="clickTwelveEight()" style="width: 20%; height: 100%; border-radius: 5px; margin-left: 5%;background-color: #FFFFFF;  float: left;" :model="eight">
              <div style="width: 30%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ eight }}口</span>
                <toggle-switch :markToggled="bank8SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="eight" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img8" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank8">{{ bank8 }}</span></div>
              </div>
            </div>
            <div id="twelveNine" @click="clickTwelveNine()" style="width: 20%; height: 100%; border-radius: 5px; margin-left: 5%;background-color: #FFFFFF;  float: left;" :model="nine">
              <div style="width: 30%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ nine }}口</span>
                <toggle-switch :markToggled="bank9SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="nine" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img9" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank9">{{ bank9 }}</span></div>
              </div>
            </div>
          </div>
          <div class="line4" style="width: 100%;height: 20%;margin-top: 1%">
            <div id="twelveTen" @click="clickTwelveTen()" style="width: 20%; height: 100%; border-radius: 5px;margin-left: 20%;background-color: #FFFFFF; float: left;" :model="ten">
              <div style="width: 30%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ ten }}口</span>
                <toggle-switch :markToggled="bank10SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="ten" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img10" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank10">{{ bank10 }}</span></div>
              </div>
            </div>
            <div id="twelveEleven" @click="clickTwelveEleven()" style="width: 20%; height: 100%; border-radius: 5px; margin-left: 5%;background-color: #FFFFFF; float: left;" :model="eleven">
              <div style="width: 30%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ eleven }}口</span>
                <toggle-switch :markToggled="bank11SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="eleven" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img11" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank11">{{ bank11 }}</span></div>
              </div>
            </div>
            <div id="twelveTwelve" @click="clickTwelveTwelve()" style="width: 20%; height: 100%; border-radius: 5px; margin-left: 5%;background-color: #FFFFFF; float: left;" :model="twelve">
              <div style="width: 30%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ twelve }}口</span>
                <toggle-switch :markToggled="bank12SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="twelve" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img12" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank12">{{ bank12 }}</span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="twentyFourDevice" id="twentyFourDevice" style="width: 100%;height: 100%;">
          <div class="line1" style="width: 100%;height: 20%;margin-top: 1%;">
            <div id="p24S1" @click="clickP24S1()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="one">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ one }}口</span>
                <toggle-switch :markToggled="bank1SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="one" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 80%; float: right; margin-right: 4%;margin-top: 6%">
                <img :src="img1" alt="" sstyle="width: 100%; height: 100%;"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank1">{{bank1}}</span></div>
              </div>
            </div>
            <div id="p24S2" @click="clickP24S2()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="two">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ two }}口</span>
                <toggle-switch :markToggled="bank2SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="two" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img2" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank2">{{ bank2 }}</span></div>
              </div>
            </div>
            <div id="p24S3" @click="clickP24S3()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="three">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ three }}口</span>
                <toggle-switch :markToggled="bank3SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="three" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img3" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank3">{{ bank3 }}</span></div>
              </div>
            </div>
            <div id="p24S4" @click="clickP24S4()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="four">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ four }}口</span>
                <toggle-switch :markToggled="bank4SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="four" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img4" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank4">{{ bank4 }}</span></div>
              </div>
            </div>
            <div id="p24S5" @click="clickP24S5()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="five">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ five }}口</span>
                <toggle-switch :markToggled="bank5SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="five" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img5" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank5">{{ bank5 }}</span></div>
              </div>
            </div>
            <div id="p24S6" @click="clickP24S6()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="six">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ six }}口</span>
                <toggle-switch :markToggled="bank6SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="six" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img6" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank6">{{ bank6 }}</span></div>
              </div>
            </div>
          </div>
          <div class="line2" style="width: 100%;height: 20%;margin-top: 1%">
            <div id="p24S7"  @click="clickP24S7()"  style="width: 13%; height: 100%; border-radius: 5px; margin-left: 3%;background-color: #FFFFFF;float: left;" :model="seven">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ seven }}口</span>
                <toggle-switch :markToggled="bank7SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="seven" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img7" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank7">{{ bank7 }}</span></div>
              </div>
            </div>
            <div id="p24S8"  @click="clickP24S8()"  style="width: 13%; height: 100%; border-radius: 5px; margin-left: 3%;background-color: #FFFFFF;float: left;" :model="eight">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ eight }}口</span>
                <toggle-switch :markToggled="bank8SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="eight" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img8" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank8">{{ bank8 }}</span></div>
              </div>
            </div>
            <div id="p24S9"  @click="clickP24S9()"  style="width: 13%; height: 100%; border-radius: 5px; margin-left: 3%;background-color: #FFFFFF;float: left;" :model="nine">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ nine }}口</span>
                <toggle-switch :markToggled="bank9SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="nine" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img9" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank9">{{ bank9 }}</span></div>
              </div>
            </div>
            <div id="p24S10" @click="clickP24S10()" style="width: 13%; height: 100%; border-radius: 5px; margin-left: 3%;background-color: #FFFFFF;float: left;" :model="ten">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ ten }}口</span>
                <toggle-switch :markToggled="bank10SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="ten" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img10" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank10">{{ bank10 }}</span></div>
              </div>
            </div>
            <div id="p24S11" @click="clickP24S11()" style="width: 13%; height: 100%; border-radius: 5px; margin-left: 3%;background-color: #FFFFFF;float: left;" :model="eleven">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ eleven }}口</span>
                <toggle-switch :markToggled="bank11SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="eleven" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img11" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank11">{{ bank11 }}</span></div>
              </div>
            </div>
            <div id="p24S12" @click="clickP24S12()" style="width: 13%; height: 100%; border-radius: 5px; margin-left: 3%;background-color: #FFFFFF;float: left;" :model="twelve">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ twelve }}口</span>
                <toggle-switch :markToggled="bank12SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="twelve" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img12" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank12">{{ bank12 }}</span></div>
              </div>
            </div>
          </div>
          <div class="line3" style="width: 100%;height: 20%;margin-top: 1%">
            <div id="p24S13" @click="clickP24S13()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="thirteen">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ thirteen }}口</span>
                <toggle-switch :markToggled="bank13SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="thirteen" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 80%; float: right; margin-right: 4%;margin-top: 6%">
                <img :src="img13" alt="" sstyle="width: 100%; height: 100%;"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank13">{{bank13}}</span></div>
              </div>
            </div>
            <div id="p24S14" @click="clickP24S14()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="fourteen">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ fourteen }}口</span>
                <toggle-switch :markToggled="bank14SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="fourteen" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img14" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank14">{{ bank14 }}</span></div>
              </div>
            </div>
            <div id="p24S15" @click="clickP24S15()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="fifteen">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ fifteen }}口</span>
                <toggle-switch :markToggled="bank15SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="fifteen" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img15" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank15">{{ bank15 }}</span></div>
              </div>
            </div>
            <div id="p24S16" @click="clickP24S16()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="sixteen">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ sixteen }}口</span>
                <toggle-switch :markToggled="bank16SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="sixteen" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img16" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank16">{{ bank16 }}</span></div>
              </div>
            </div>
            <div id="p24S17" @click="clickP24S17()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="seventeen">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ seventeen }}口</span>
                <toggle-switch :markToggled="bank17SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="seventeen" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img17" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank17">{{ bank17 }}</span></div>
              </div>
            </div>
            <div id="p24S18" @click="clickP24S18()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="eighteen">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ eighteen }}口</span>
                <toggle-switch :markToggled="bank18SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="eighteen" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img18" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank18">{{ bank18 }}</span></div>
              </div>
            </div>
          </div>
          <div class="line4" style="width: 100%;height: 20%;margin-top: 1%">
            <div id="p24S19" @click="clickP24S19()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="nineteen">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ nineteen }}口</span>
                <toggle-switch :markToggled="bank19SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="nineteen" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 80%; float: right; margin-right: 4%;margin-top: 6%">
                <img :src="img19" alt="" sstyle="width: 100%; height: 100%;"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank19">{{bank19}}</span></div>
              </div>
            </div>
            <div id="p24S20" @click="clickP24S20()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="twenty">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ twenty }}口</span>
                <toggle-switch :markToggled="bank20SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="twenty" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img20" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank20">{{ bank20 }}</span></div>
              </div>
            </div>
            <div id="p24S21" @click="clickP24S21()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="twentyOne">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ twentyOne }}口</span>
                <toggle-switch :markToggled="bank21SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="twentyOne" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img21" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank21">{{ bank21 }}</span></div>
              </div>
            </div>
            <div id="p24S22" @click="clickP24S22()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="twentyTwo">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ twentyTwo }}口</span>
                <toggle-switch :markToggled="bank22SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="twentyTwo" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img22" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank22">{{ bank22 }}</span></div>
              </div>
            </div>
            <div id="p24S23" @click="clickP24S23()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="twentyThree">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ twentyThree }}口</span>
                <toggle-switch :markToggled="bank23SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="twentyThree" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img23" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank23">{{ bank23 }}</span></div>
              </div>
            </div>
            <div id="p24S24" @click="clickP24S24()" style="width: 13%; height: 100%; border-radius: 5px;margin-left: 3%;background-color: #FFFFFF;float: left;" :model="twentyFour">
              <div style="width: 40%; height: 100%; float: left;">
                <span style="font-size: 0.5rem; color: #666666; display:block; margin-top: 10%">{{ twentyFour }}口</span>
                <toggle-switch :markToggled="bank24SlotDestroyStatus"  :powerBoxId="powerBoxId" :powerSlot="twentyFour" />
              </div>
              <el-divider direction="vertical" style="width: 10em"></el-divider>
              <div class="image" style="width: 50%; height: 800%; float: right; margin-right: 4%; margin-top: 6%;">
                <img :src="img24" alt="" sstyle="width: 80%; height: 80%"/>
                <div style="width: 100%; height: 20%;margin-top: 5%"><span style="font-size: 0.25rem" :model="bank24">{{ bank24 }}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bank-order v-if="bankOrderDialog" ref="bankOrder"></bank-order>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
import {getDevice, pop, restart, allEject} from '../../api/devicemanagement/device'
import axios from 'axios'
import BankOrder from './bankOrder.vue'
import ToggleSwitch from '../../components/switcher/ToggleSwitch'
export default {
  name: 'Device',
  data () {
    return {
      img1: require('../../../static/image/device/kong.png'),
      img2: require('../../../static/image/device/kong.png'),
      img3: require('../../../static/image/device/kong.png'),
      img4: require('../../../static/image/device/kong.png'),
      img5: require('../../../static/image/device/kong.png'),
      img6: require('../../../static/image/device/kong.png'),
      img7: require('../../../static/image/device/kong.png'),
      img8: require('../../../static/image/device/kong.png'),
      img9: require('../../../static/image/device/kong.png'),
      img10: require('../../../static/image/device/kong.png'),
      img11: require('../../../static/image/device/kong.png'),
      img12: require('../../../static/image/device/kong.png'),
      img13: require('../../../static/image/device/kong.png'),
      img14: require('../../../static/image/device/kong.png'),
      img15: require('../../../static/image/device/kong.png'),
      img16: require('../../../static/image/device/kong.png'),
      img17: require('../../../static/image/device/kong.png'),
      img18: require('../../../static/image/device/kong.png'),
      img19: require('../../../static/image/device/kong.png'),
      img20: require('../../../static/image/device/kong.png'),
      img21: require('../../../static/image/device/kong.png'),
      img22: require('../../../static/image/device/kong.png'),
      img23: require('../../../static/image/device/kong.png'),
      img24: require('../../../static/image/device/kong.png'),
      bankOrderDialog: false,
      erweimaSrc: '',
      erweimaSrcSize: 85,
      powerBoxIdOrPowerBankId: '',
      deviceId: '',
      deviceState: '',
      one: 1,
      two: 2,
      three: 3,
      four: 4,
      five: 5,
      six: 6,
      seven: 7,
      eight: 8,
      nine: 9,
      ten: 10,
      eleven: 11,
      twelve: 12,
      thirteen: 13,
      fourteen: 14,
      fifteen: 15,
      sixteen: 16,
      seventeen: 17,
      eighteen: 18,
      nineteen: 19,
      twenty: 20,
      twentyOne: 21,
      twentyTwo: 22,
      twentyThree: 23,
      twentyFour: 24,
      choice: '',
      loading: false,
      deviceInfo: '',
      powerBoxId: '',
      bank1: '',
      bank1SlotDestroyStatus: '',
      bank2: '',
      bank2SlotDestroyStatus: '',
      bank3: '',
      bank3SlotDestroyStatus: '',
      bank4: '',
      bank4SlotDestroyStatus: '',
      bank5: '',
      bank5SlotDestroyStatus: '',
      bank6: '',
      bank6SlotDestroyStatus: '',
      bank7: '',
      bank7SlotDestroyStatus: '',
      bank8: '',
      bank8SlotDestroyStatus: '',
      bank9: '',
      bank9SlotDestroyStatus: '',
      bank10: '',
      bank10SlotDestroyStatus: '',
      bank11: '',
      bank11SlotDestroyStatus: '',
      bank12: '',
      bank12SlotDestroyStatus: '',
      bank13: '',
      bank13SlotDestroyStatus: '',
      bank14: '',
      bank14SlotDestroyStatus: '',
      bank15: '',
      bank15SlotDestroyStatus: '',
      bank16: '',
      bank16SlotDestroyStatus: '',
      bank17: '',
      bank17SlotDestroyStatus: '',
      bank18: '',
      bank18SlotDestroyStatus: '',
      bank19: '',
      bank19SlotDestroyStatus: '',
      bank20: '',
      bank20SlotDestroyStatus: '',
      bank21: '',
      bank21SlotDestroyStatus: '',
      bank22: '',
      bank22SlotDestroyStatus: '',
      bank23: '',
      bank23SlotDestroyStatus: '',
      bank24: '',
      bank24SlotDestroyStatus: '',
      times: 5
    }
  },
  components: {
    vueQr, BankOrder, ToggleSwitch
  },
  methods: {
    clickSixOne () {
      let sixOne = document.getElementById('sixOne')
      let sixTwo = document.getElementById('sixTwo')
      let sixThree = document.getElementById('sixThree')
      let sixFour = document.getElementById('sixFour')
      let sixFive = document.getElementById('sixFive')
      let sixSix = document.getElementById('sixSix')
      sixOne.style.border = '2px solid yellow'
      sixTwo.style.border = '0px'
      sixThree.style.border = '0px'
      sixFour.style.border = '0px'
      sixFive.style.border = '0px'
      sixSix.style.border = '0px'
      this.choice = this.one
    },
    clickSixTwo () {
      let sixOne = document.getElementById('sixOne')
      let sixTwo = document.getElementById('sixTwo')
      let sixThree = document.getElementById('sixThree')
      let sixFour = document.getElementById('sixFour')
      let sixFive = document.getElementById('sixFive')
      let sixSix = document.getElementById('sixSix')
      sixOne.style.border = '0'
      sixTwo.style.border = '2px solid yellow'
      sixThree.style.border = '0px'
      sixFour.style.border = '0px'
      sixFive.style.border = '0px'
      sixSix.style.border = '0px'
      this.choice = this.two
    },
    clickSixThree () {
      let sixOne = document.getElementById('sixOne')
      let sixTwo = document.getElementById('sixTwo')
      let sixThree = document.getElementById('sixThree')
      let sixFour = document.getElementById('sixFour')
      let sixFive = document.getElementById('sixFive')
      let sixSix = document.getElementById('sixSix')
      sixOne.style.border = '0'
      sixTwo.style.border = '0'
      sixThree.style.border = '2px solid yellow'
      sixFour.style.border = '0px'
      sixFive.style.border = '0px'
      sixSix.style.border = '0px'
      this.choice = this.three
    },
    clickSixFour () {
      let sixOne = document.getElementById('sixOne')
      let sixTwo = document.getElementById('sixTwo')
      let sixThree = document.getElementById('sixThree')
      let sixFour = document.getElementById('sixFour')
      let sixFive = document.getElementById('sixFive')
      let sixSix = document.getElementById('sixSix')
      sixOne.style.border = '0'
      sixTwo.style.border = '0'
      sixThree.style.border = '0'
      sixFour.style.border = '2px solid yellow'
      sixFive.style.border = '0px'
      sixSix.style.border = '0px'
      this.choice = this.four
    },
    clickSixFive () {
      let sixOne = document.getElementById('sixOne')
      let sixTwo = document.getElementById('sixTwo')
      let sixThree = document.getElementById('sixThree')
      let sixFour = document.getElementById('sixFour')
      let sixFive = document.getElementById('sixFive')
      let sixSix = document.getElementById('sixSix')
      sixOne.style.border = '0'
      sixTwo.style.border = '0'
      sixThree.style.border = '0'
      sixFour.style.border = '0'
      sixFive.style.border = '2px solid yellow'
      sixSix.style.border = '0px'
      this.choice = this.five
    },
    clickSixSix () {
      let sixOne = document.getElementById('sixOne')
      let sixTwo = document.getElementById('sixTwo')
      let sixThree = document.getElementById('sixThree')
      let sixFour = document.getElementById('sixFour')
      let sixFive = document.getElementById('sixFive')
      let sixSix = document.getElementById('sixSix')
      sixOne.style.border = '0'
      sixTwo.style.border = '0'
      sixThree.style.border = '0'
      sixFour.style.border = '0'
      sixFive.style.border = '0'
      sixSix.style.border = '2px solid yellow'
      this.choice = this.six
    },
    clickOne () {
      let one = document.getElementById('one')
      let two = document.getElementById('two')
      let three = document.getElementById('three')
      let four = document.getElementById('four')
      let five = document.getElementById('five')
      let six = document.getElementById('six')
      let seven = document.getElementById('seven')
      let eight = document.getElementById('eight')
      let nine = document.getElementById('nine')
      one.style.border = '2px solid yellow'
      two.style.border = '0px'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      this.choice = this.one
    },
    clickTwo () {
      let one = document.getElementById('one')
      let two = document.getElementById('two')
      let three = document.getElementById('three')
      let four = document.getElementById('four')
      let five = document.getElementById('five')
      let six = document.getElementById('six')
      let seven = document.getElementById('seven')
      let eight = document.getElementById('eight')
      let nine = document.getElementById('nine')
      one.style.border = '0px'
      two.style.border = '2px solid yellow'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      this.choice = this.two
    },
    clickThree () {
      let one = document.getElementById('one')
      let two = document.getElementById('two')
      let three = document.getElementById('three')
      let four = document.getElementById('four')
      let five = document.getElementById('five')
      let six = document.getElementById('six')
      let seven = document.getElementById('seven')
      let eight = document.getElementById('eight')
      let nine = document.getElementById('nine')
      one.style.border = '0px'
      two.style.border = '0px'
      three.style.border = '2px solid yellow'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      this.choice = this.three
    },
    clickFour () {
      let one = document.getElementById('one')
      let two = document.getElementById('two')
      let three = document.getElementById('three')
      let four = document.getElementById('four')
      let five = document.getElementById('five')
      let six = document.getElementById('six')
      let seven = document.getElementById('seven')
      let eight = document.getElementById('eight')
      let nine = document.getElementById('nine')
      one.style.border = '0px'
      two.style.border = '0px'
      three.style.border = '0px'
      four.style.border = '2px solid yellow'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      this.choice = this.four
    },
    clickFive () {
      let one = document.getElementById('one')
      let two = document.getElementById('two')
      let three = document.getElementById('three')
      let four = document.getElementById('four')
      let five = document.getElementById('five')
      let six = document.getElementById('six')
      let seven = document.getElementById('seven')
      let eight = document.getElementById('eight')
      let nine = document.getElementById('nine')
      one.style.border = '0px'
      two.style.border = '0px'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '2px solid yellow'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      this.choice = this.five
    },
    clickSix () {
      let one = document.getElementById('one')
      let two = document.getElementById('two')
      let three = document.getElementById('three')
      let four = document.getElementById('four')
      let five = document.getElementById('five')
      let six = document.getElementById('six')
      let seven = document.getElementById('seven')
      let eight = document.getElementById('eight')
      let nine = document.getElementById('nine')
      one.style.border = '0px'
      two.style.border = '0px'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '2px solid yellow'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      this.choice = this.six
    },
    clickSeven () {
      let one = document.getElementById('one')
      let two = document.getElementById('two')
      let three = document.getElementById('three')
      let four = document.getElementById('four')
      let five = document.getElementById('five')
      let six = document.getElementById('six')
      let seven = document.getElementById('seven')
      let eight = document.getElementById('eight')
      let nine = document.getElementById('nine')
      one.style.border = '0px'
      two.style.border = '0px'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '2px solid yellow'
      eight.style.border = '0px'
      nine.style.border = '0px'
      this.choice = this.seven
    },
    clickEight () {
      let one = document.getElementById('one')
      let two = document.getElementById('two')
      let three = document.getElementById('three')
      let four = document.getElementById('four')
      let five = document.getElementById('five')
      let six = document.getElementById('six')
      let seven = document.getElementById('seven')
      let eight = document.getElementById('eight')
      let nine = document.getElementById('nine')
      one.style.border = '0px'
      two.style.border = '0px'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '2px solid yellow'
      nine.style.border = '0px'
      this.choice = this.eight
    },
    clickNine () {
      let one = document.getElementById('one')
      let two = document.getElementById('two')
      let three = document.getElementById('three')
      let four = document.getElementById('four')
      let five = document.getElementById('five')
      let six = document.getElementById('six')
      let seven = document.getElementById('seven')
      let eight = document.getElementById('eight')
      let nine = document.getElementById('nine')
      one.style.border = '0px'
      two.style.border = '0px'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '2px solid yellow'
      this.choice = this.nine
    },
    clickTwelveOne () {
      let one = document.getElementById('twelveOne')
      let two = document.getElementById('twelveTwo')
      let three = document.getElementById('twelveThree')
      let four = document.getElementById('twelveFour')
      let five = document.getElementById('twelveFive')
      let six = document.getElementById('twelveSix')
      let seven = document.getElementById('twelveSeven')
      let eight = document.getElementById('twelveEight')
      let nine = document.getElementById('twelveNine')
      let ten = document.getElementById('twelveTen')
      let eleven = document.getElementById('twelveEleven')
      let twelve = document.getElementById('twelveTwelve')
      one.style.border = '2px solid yellow'
      two.style.border = '0px'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      ten.style.border = '0px'
      eleven.style.border = '0px'
      twelve.style.border = '0px'
      this.choice = this.one
    },
    clickTwelveTwo () {
      let one = document.getElementById('twelveOne')
      let two = document.getElementById('twelveTwo')
      let three = document.getElementById('twelveThree')
      let four = document.getElementById('twelveFour')
      let five = document.getElementById('twelveFive')
      let six = document.getElementById('twelveSix')
      let seven = document.getElementById('twelveSeven')
      let eight = document.getElementById('twelveEight')
      let nine = document.getElementById('twelveNine')
      let ten = document.getElementById('twelveTen')
      let eleven = document.getElementById('twelveEleven')
      let twelve = document.getElementById('twelveTwelve')
      one.style.border = '0'
      two.style.border = '2px solid yellow'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      ten.style.border = '0px'
      eleven.style.border = '0px'
      twelve.style.border = '0px'
      this.choice = this.two
    },
    clickTwelveThree () {
      let one = document.getElementById('twelveOne')
      let two = document.getElementById('twelveTwo')
      let three = document.getElementById('twelveThree')
      let four = document.getElementById('twelveFour')
      let five = document.getElementById('twelveFive')
      let six = document.getElementById('twelveSix')
      let seven = document.getElementById('twelveSeven')
      let eight = document.getElementById('twelveEight')
      let nine = document.getElementById('twelveNine')
      let ten = document.getElementById('twelveTen')
      let eleven = document.getElementById('twelveEleven')
      let twelve = document.getElementById('twelveTwelve')
      one.style.border = '0'
      two.style.border = '0'
      three.style.border = '2px solid yellow'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      ten.style.border = '0px'
      eleven.style.border = '0px'
      twelve.style.border = '0px'
      this.choice = this.three
    },
    clickTwelveFour () {
      let one = document.getElementById('twelveOne')
      let two = document.getElementById('twelveTwo')
      let three = document.getElementById('twelveThree')
      let four = document.getElementById('twelveFour')
      let five = document.getElementById('twelveFive')
      let six = document.getElementById('twelveSix')
      let seven = document.getElementById('twelveSeven')
      let eight = document.getElementById('twelveEight')
      let nine = document.getElementById('twelveNine')
      let ten = document.getElementById('twelveTen')
      let eleven = document.getElementById('twelveEleven')
      let twelve = document.getElementById('twelveTwelve')
      one.style.border = '0'
      two.style.border = '0'
      three.style.border = '0px'
      four.style.border = '2px solid yellow'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      ten.style.border = '0px'
      eleven.style.border = '0px'
      twelve.style.border = '0px'
      this.choice = this.four
    },
    clickTwelveFive () {
      let one = document.getElementById('twelveOne')
      let two = document.getElementById('twelveTwo')
      let three = document.getElementById('twelveThree')
      let four = document.getElementById('twelveFour')
      let five = document.getElementById('twelveFive')
      let six = document.getElementById('twelveSix')
      let seven = document.getElementById('twelveSeven')
      let eight = document.getElementById('twelveEight')
      let nine = document.getElementById('twelveNine')
      let ten = document.getElementById('twelveTen')
      let eleven = document.getElementById('twelveEleven')
      let twelve = document.getElementById('twelveTwelve')
      one.style.border = '0'
      two.style.border = '0'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '2px solid yellow'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      ten.style.border = '0px'
      eleven.style.border = '0px'
      twelve.style.border = '0px'
      this.choice = this.five
    },
    clickTwelveSix () {
      let one = document.getElementById('twelveOne')
      let two = document.getElementById('twelveTwo')
      let three = document.getElementById('twelveThree')
      let four = document.getElementById('twelveFour')
      let five = document.getElementById('twelveFive')
      let six = document.getElementById('twelveSix')
      let seven = document.getElementById('twelveSeven')
      let eight = document.getElementById('twelveEight')
      let nine = document.getElementById('twelveNine')
      let ten = document.getElementById('twelveTen')
      let eleven = document.getElementById('twelveEleven')
      let twelve = document.getElementById('twelveTwelve')
      one.style.border = '0px'
      two.style.border = '0px'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '2px solid yellow'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      ten.style.border = '0px'
      eleven.style.border = '0px'
      twelve.style.border = '0px'
      this.choice = this.six
    },
    clickTwelveSeven () {
      let one = document.getElementById('twelveOne')
      let two = document.getElementById('twelveTwo')
      let three = document.getElementById('twelveThree')
      let four = document.getElementById('twelveFour')
      let five = document.getElementById('twelveFive')
      let six = document.getElementById('twelveSix')
      let seven = document.getElementById('twelveSeven')
      let eight = document.getElementById('twelveEight')
      let nine = document.getElementById('twelveNine')
      let ten = document.getElementById('twelveTen')
      let eleven = document.getElementById('twelveEleven')
      let twelve = document.getElementById('twelveTwelve')
      one.style.border = '0'
      two.style.border = '0'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '2px solid yellow'
      eight.style.border = '0px'
      nine.style.border = '0px'
      ten.style.border = '0px'
      eleven.style.border = '0px'
      twelve.style.border = '0px'
      this.choice = this.seven
    },
    clickTwelveEight () {
      let one = document.getElementById('twelveOne')
      let two = document.getElementById('twelveTwo')
      let three = document.getElementById('twelveThree')
      let four = document.getElementById('twelveFour')
      let five = document.getElementById('twelveFive')
      let six = document.getElementById('twelveSix')
      let seven = document.getElementById('twelveSeven')
      let eight = document.getElementById('twelveEight')
      let nine = document.getElementById('twelveNine')
      let ten = document.getElementById('twelveTen')
      let eleven = document.getElementById('twelveEleven')
      let twelve = document.getElementById('twelveTwelve')
      one.style.border = '0'
      two.style.border = '0'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '2px solid yellow'
      nine.style.border = '0px'
      ten.style.border = '0px'
      eleven.style.border = '0px'
      twelve.style.border = '0px'
      this.choice = this.eight
    },
    clickTwelveNine () {
      let one = document.getElementById('twelveOne')
      let two = document.getElementById('twelveTwo')
      let three = document.getElementById('twelveThree')
      let four = document.getElementById('twelveFour')
      let five = document.getElementById('twelveFive')
      let six = document.getElementById('twelveSix')
      let seven = document.getElementById('twelveSeven')
      let eight = document.getElementById('twelveEight')
      let nine = document.getElementById('twelveNine')
      let ten = document.getElementById('twelveTen')
      let eleven = document.getElementById('twelveEleven')
      let twelve = document.getElementById('twelveTwelve')
      one.style.border = '0'
      two.style.border = '0'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '2px solid yellow'
      ten.style.border = '0px'
      eleven.style.border = '0px'
      twelve.style.border = '0px'
      this.choice = this.nine
    },
    clickTwelveTen () {
      let one = document.getElementById('twelveOne')
      let two = document.getElementById('twelveTwo')
      let three = document.getElementById('twelveThree')
      let four = document.getElementById('twelveFour')
      let five = document.getElementById('twelveFive')
      let six = document.getElementById('twelveSix')
      let seven = document.getElementById('twelveSeven')
      let eight = document.getElementById('twelveEight')
      let nine = document.getElementById('twelveNine')
      let ten = document.getElementById('twelveTen')
      let eleven = document.getElementById('twelveEleven')
      let twelve = document.getElementById('twelveTwelve')
      one.style.border = '0'
      two.style.border = '0'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      ten.style.border = '2px solid yellow'
      eleven.style.border = '0px'
      twelve.style.border = '0px'
      this.choice = this.ten
    },
    clickTwelveEleven () {
      let one = document.getElementById('twelveOne')
      let two = document.getElementById('twelveTwo')
      let three = document.getElementById('twelveThree')
      let four = document.getElementById('twelveFour')
      let five = document.getElementById('twelveFive')
      let six = document.getElementById('twelveSix')
      let seven = document.getElementById('twelveSeven')
      let eight = document.getElementById('twelveEight')
      let nine = document.getElementById('twelveNine')
      let ten = document.getElementById('twelveTen')
      let eleven = document.getElementById('twelveEleven')
      let twelve = document.getElementById('twelveTwelve')
      one.style.border = '0'
      two.style.border = '0'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      ten.style.border = '0px'
      eleven.style.border = '2px solid yellow'
      twelve.style.border = '0px'
      this.choice = this.eleven
    },
    clickTwelveTwelve () {
      let one = document.getElementById('twelveOne')
      let two = document.getElementById('twelveTwo')
      let three = document.getElementById('twelveThree')
      let four = document.getElementById('twelveFour')
      let five = document.getElementById('twelveFive')
      let six = document.getElementById('twelveSix')
      let seven = document.getElementById('twelveSeven')
      let eight = document.getElementById('twelveEight')
      let nine = document.getElementById('twelveNine')
      let ten = document.getElementById('twelveTen')
      let eleven = document.getElementById('twelveEleven')
      let twelve = document.getElementById('twelveTwelve')
      one.style.border = '0'
      two.style.border = '0'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      ten.style.border = '0px'
      eleven.style.border = '0px'
      twelve.style.border = '2px solid yellow'
      this.choice = this.twelve
    },
    clickP24S1 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '2px solid yellow'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.one
    },
    clickP24S2 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '2px solid yellow'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.two
    },
    clickP24S3 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '2px solid yellow'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.three
    },
    clickP24S4 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '2px solid yellow'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.four
    },
    clickP24S5 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '2px solid yellow'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.five
    },
    clickP24S6 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '2px solid yellow'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.six
    },
    clickP24S7 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '2px solid yellow'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.seven
    },
    clickP24S8 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '2px solid yellow'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.eight
    },
    clickP24S9 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '2px solid yellow'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.nine
    },
    clickP24S10 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '2px solid yellow'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.ten
    },
    clickP24S11 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '2px solid yellow'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.eleven
    },
    clickP24S12 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '2px solid yellow'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.twelve
    },
    clickP24S13 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '2px solid yellow'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.thirteen
    },
    clickP24S14 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '2px solid yellow'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.fourteen
    },
    clickP24S15 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '2px solid yellow'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.fifteen
    },
    clickP24S16 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '2px solid yellow'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.sixteen
    },
    clickP24S17 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '2px solid yellow'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.seventeen
    },
    clickP24S18 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '2px solid yellow'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.eighteen
    },
    clickP24S19 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '2px solid yellow'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.nineteen
    },
    clickP24S20 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '2px solid yellow'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.twenty
    },
    clickP24S21 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '2px solid yellow'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.twentyOne
    },
    clickP24S22 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '2px solid yellow'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
      this.choice = this.twentyTwo
    },
    clickP24S23 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '2px solid yellow'
      p24S24.style.border = '0px'
      this.choice = this.twentyThree
    },
    clickP24S24 () {
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '2px solid yellow'
      this.choice = this.twentyFour
    },
    getDeviceInfo () {
      this.loading = true
      this.img1 = require('../../../static/image/device/kong.png')
      this.img2 = require('../../../static/image/device/kong.png')
      this.img3 = require('../../../static/image/device/kong.png')
      this.img4 = require('../../../static/image/device/kong.png')
      this.img5 = require('../../../static/image/device/kong.png')
      this.img6 = require('../../../static/image/device/kong.png')
      this.img7 = require('../../../static/image/device/kong.png')
      this.img8 = require('../../../static/image/device/kong.png')
      this.img9 = require('../../../static/image/device/kong.png')
      this.img10 = require('../../../static/image/device/kong.png')
      this.img11 = require('../../../static/image/device/kong.png')
      this.img12 = require('../../../static/image/device/kong.png')
      this.img13 = require('../../../static/image/device/kong.png')
      this.img14 = require('../../../static/image/device/kong.png')
      this.img15 = require('../../../static/image/device/kong.png')
      this.img16 = require('../../../static/image/device/kong.png')
      this.img17 = require('../../../static/image/device/kong.png')
      this.img18 = require('../../../static/image/device/kong.png')
      this.img19 = require('../../../static/image/device/kong.png')
      this.img20 = require('../../../static/image/device/kong.png')
      this.img21 = require('../../../static/image/device/kong.png')
      this.img22 = require('../../../static/image/device/kong.png')
      this.img23 = require('../../../static/image/device/kong.png')
      this.img24 = require('../../../static/image/device/kong.png')
      const deviceId = {
        'deviceId': this.powerBoxIdOrPowerBankId
      }
      getDevice(deviceId).then(result => {
        if (result.code == '000000') {
          this.loading = false
          this.bank1 = ''
          this.bank1SlotDestroyStatus = ''
          this.bank2 = ''
          this.bank2SlotDestroyStatus = ''
          this.bank3 = ''
          this.bank3SlotDestroyStatus = ''
          this.bank4 = ''
          this.bank4SlotDestroyStatus = ''
          this.bank5 = ''
          this.bank5SlotDestroyStatus = ''
          this.bank6 = ''
          this.bank6SlotDestroyStatus = ''
          this.bank7 = ''
          this.bank7SlotDestroyStatus = ''
          this.bank8 = ''
          this.bank8SlotDestroyStatus = ''
          this.bank9 = ''
          this.bank9SlotDestroyStatus = ''
          this.bank10 = ''
          this.bank10SlotDestroyStatus = ''
          this.bank11 = ''
          this.bank11SlotDestroyStatus = ''
          this.bank12 = ''
          this.bank12SlotDestroyStatus = ''
          this.bank13 = ''
          this.bank13SlotDestroyStatus = ''
          this.bank14 = ''
          this.bank14SlotDestroyStatus = ''
          this.bank15 = ''
          this.bank15SlotDestroyStatus = ''
          this.bank16 = ''
          this.bank16SlotDestroyStatus = ''
          this.bank17 = ''
          this.bank17SlotDestroyStatus = ''
          this.bank18 = ''
          this.bank18SlotDestroyStatus = ''
          this.bank19 = ''
          this.bank19SlotDestroyStatus = ''
          this.bank20 = ''
          this.bank20SlotDestroyStatus = ''
          this.bank21 = ''
          this.bank21SlotDestroyStatus = ''
          this.bank22 = ''
          this.bank22SlotDestroyStatus = ''
          this.bank23 = ''
          this.bank23SlotDestroyStatus = ''
          this.bank24 = ''
          this.bank24SlotDestroyStatus = ''
          this.deviceId = result.data.deviceId
          this.erweimaSrc = 'https://www.ziyouyunchuang.com/rent?id=' + result.data.deviceId
          if (result.data.powerBankOrderInfoDto != null) {
            this.bankOrder(result.data.powerBankOrderInfoDto)
          } else {
            if (result.data.slotInfoVos != null) {
              this.deviceInfo = result.data.slotInfoVos
              this.powerBoxId = result.data.powerBoxId
              this.deviceState = '在线'
              if (result.data.socket == '6') {
                let sixDevice = document.getElementById('sixDevice')
                sixDevice.style.display = 'block'
                let twelveDevice = document.getElementById('twelveDevice')
                twelveDevice.style.display = 'none'
                let twentyFourDevice = document.getElementById('twentyFourDevice')
                twentyFourDevice.style.display = 'none'
                let eightDevice = document.getElementById('eightDevice')
                eightDevice.style.display = 'none'
                let nineDevice = document.getElementById('nineDevice')
                nineDevice.style.display = 'none'
                for (let i = 0; i < result.data.slotInfoVos.length; i++) {
                  if (result.data.slotInfoVos[i].slot == '1') {
                    this.bank1SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank1 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img1 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img1 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img1 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img1 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '2') {
                    this.bank2SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank2 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img2 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img2 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img2 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img2 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '3') {
                    this.bank3SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank3 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img3 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img3 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img3 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img3 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '4') {
                    this.bank4SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank4 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img4 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img4 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img4 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img4 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '5') {
                    this.bank5SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank5 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img5 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img5 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img5 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img5 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '6') {
                    this.bank6SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank6 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img6 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img6 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img6 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img6 = require('../../../static/image/device/didianliang.png')
                    }
                  }
                }
              } else if (result.data.socket == '8') {
                let sixDevice = document.getElementById('sixDevice')
                sixDevice.style.display = 'none'
                let twelveDevice = document.getElementById('twelveDevice')
                twelveDevice.style.display = 'none'
                let twentyFourDevice = document.getElementById('twentyFourDevice')
                twentyFourDevice.style.display = 'none'
                let eightDevice = document.getElementById('eightDevice')
                eightDevice.style.display = 'block'
                let nineDevice = document.getElementById('nineDevice')
                nineDevice.style.display = 'none'
                for (let i = 0; i < result.data.slotInfoVos.length; i++) {
                  if (result.data.slotInfoVos[i].slot == '1') {
                    this.bank1SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank1 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img1 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img1 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img1 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img1 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '2') {
                    this.bank2SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank2 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img2 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img2 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img2 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img2 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '3') {
                    this.bank3SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank3 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img3 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img3 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img3 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img3 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '4') {
                    this.bank4SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank4 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img4 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img4 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img4 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img4 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '5') {
                    this.bank5SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank5 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img5 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img5 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img5 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img5 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '6') {
                    this.bank6SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank6 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img6 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img6 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img6 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img6 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '7') {
                    this.bank7SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank7 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img7 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img7 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img7 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img7 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '8') {
                    this.bank8SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank8 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img8 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img8 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img8 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img8 = require('../../../static/image/device/didianliang.png')
                    }
                  }
                }
              } else if (result.data.socket == '9') {
                let sixDevice = document.getElementById('sixDevice')
                sixDevice.style.display = 'none'
                let eightDevice = document.getElementById('eightDevice')
                eightDevice.style.display = 'none'
                let twelveDevice = document.getElementById('twelveDevice')
                twelveDevice.style.display = 'none'
                let twentyFourDevice = document.getElementById('twentyFourDevice')
                twentyFourDevice.style.display = 'none'
                let nineDevice = document.getElementById('nineDevice')
                nineDevice.style.display = 'block'
                for (let i = 0; i < result.data.slotInfoVos.length; i++) {
                  if (result.data.slotInfoVos[i].slot == '1') {
                    this.bank1SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank1 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img1 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img1 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img1 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img1 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '2') {
                    this.bank2SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank2 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img2 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img2 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img2 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img2 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '3') {
                    this.bank3SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank3 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img3 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img3 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img3 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img3 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '4') {
                    this.bank4SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank4 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img4 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img4 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img4 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img4 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '5') {
                    this.bank5SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank5 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img5 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img5 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img5 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img5 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '6') {
                    this.bank6SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank6 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img6 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img6 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img6 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img6 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '7') {
                    this.bank7SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank7 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img7 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img7 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img7 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img7 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '8') {
                    this.bank8SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank8 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img8 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img8 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img8 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img8 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '9') {
                    this.bank9SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                     this.bank9 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img9 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img9 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img9 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img9 = require('../../../static/image/device/didianliang.png')
                    }
                  }
                }
              } else if (result.data.socket == '12') {
                let sixDevice = document.getElementById('sixDevice')
                sixDevice.style.display = 'none'
                let eightDevice = document.getElementById('eightDevice')
                eightDevice.style.display = 'none'
                let nineDevice = document.getElementById('nineDevice')
                nineDevice.style.display = 'none'
                let twelveDevice = document.getElementById('twelveDevice')
                twelveDevice.style.display = 'block'
                let twentyFourDevice = document.getElementById('twentyFourDevice')
                twentyFourDevice.style.display = 'none'
                for (let i = 0; i < result.data.slotInfoVos.length; i++) {
                  if (result.data.slotInfoVos[i].slot == '1') {
                    this.bank1SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank1 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img1 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img1 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img1 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img1 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '2') {
                    this.bank2SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank2 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img2 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img2 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img2 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img2 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '3') {
                    this.bank3SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank3 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img3 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img3 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img3 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img3 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '4') {
                    this.bank4SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank4 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img4 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img4 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img4 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img4 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '5') {
                    this.bank5SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank5 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img5 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img5 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img5 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img5 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '6') {
                    this.bank6SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank6 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img6 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img6 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img6 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img6 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '7') {
                    this.bank7SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank7 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img7 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img7 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img7 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img7 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '8') {
                    this.bank8SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank8 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img8 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img8 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img8 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img8 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '9') {
                    this.bank9SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank9 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img9 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img9 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img9 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img9 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '10') {
                    this.bank10SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank10 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img10 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img10 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img10 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img10 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '11') {
                    this.bank11SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank11 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img11 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img11 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img11 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img11 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '12') {
                    this.bank12SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank12 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img12 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img12 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img12 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img12 = require('../../../static/image/device/didianliang.png')
                    }
                  }
                }
              } else if (result.data.socket == '24') {
                let sixDevice = document.getElementById('sixDevice')
                sixDevice.style.display = 'none'
                let eightDevice = document.getElementById('eightDevice')
                eightDevice.style.display = 'none'
                let nineDevice = document.getElementById('nineDevice')
                nineDevice.style.display = 'none'
                let twelveDevice = document.getElementById('twelveDevice')
                twelveDevice.style.display = 'none'
                let twentyFourDevice = document.getElementById('twentyFourDevice')
                twentyFourDevice.style.display = 'block'
                for (let i = 0; i < result.data.slotInfoVos.length; i++) {
                  if (result.data.slotInfoVos[i].slot == '1') {
                    this.bank1SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank1 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img1 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img1 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img1 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img1 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '2') {
                    this.bank2SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank2 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img2 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img2 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img2 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img2 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '3') {
                    this.bank3SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank3 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img3 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img3 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img3 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img3 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '4') {
                    this.bank4SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank4 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img4 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img4 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img4 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img4 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '5') {
                    this.bank5SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank5 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img5 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img5 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img5 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img5 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '6') {
                    this.bank6SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank6 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img6 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img6 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img6 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img6 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '7') {
                    this.bank7SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank7 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img7 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img7 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img7 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img7 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '8') {
                    this.bank8SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank8 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img8 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img8 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img8 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img8 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '9') {
                    this.bank9SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank9 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img9 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img9 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img9 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img9 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '10') {
                    this.bank10SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank10 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img10 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img10 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img10 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img10 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '11') {
                    this.bank11SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank11 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img11 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img11 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img11 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img11 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '12') {
                    this.bank12SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank12 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img12 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img12 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img12 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img12 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '13') {
                    this.bank13SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank13 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img13 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img13 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img13 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img13 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '14') {
                    this.bank14SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank14 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img14 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img14 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img14 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img14 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '15') {
                    this.bank15SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank15 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img15 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img15 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img15 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img15 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '16') {
                    this.bank16SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank16 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img16 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img16 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img16 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img16 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '17') {
                    this.bank17SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank17 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img17 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img17 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img17 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img17 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '18') {
                    this.bank18SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank18 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img18 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img18 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img18 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img18 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '19') {
                    this.bank19SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank19 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img19 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img19 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img19 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img19 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '20') {
                    this.bank20SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank20 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img20 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img20 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img20 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img20 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '21') {
                    this.bank21SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank21 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img21 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img21 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img21 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img21 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '22') {
                    this.bank22SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank22 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img22 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img22 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img22 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img22 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '23') {
                    this.bank23SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank23 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img23 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img23 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img23 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img23 = require('../../../static/image/device/didianliang.png')
                    }
                  } else if (result.data.slotInfoVos[i].slot == '24') {
                    this.bank24SlotDestroyStatus = result.data.slotInfoVos[i].destroyFlag
                    this.bank24 = result.data.slotInfoVos[i].powerBankId
                    if (result.data.slotInfoVos[i].level == '4') {
                      this.img24 = require('../../../static/image/device/duodianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '3') {
                      this.img24 = require('../../../static/image/device/zhongdianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '2') {
                      this.img24 = require('../../../static/image/device/didianliang.png')
                    } else if (result.data.slotInfoVos[i].level == '1') {
                      this.img24 = require('../../../static/image/device/didianliang.png')
                    }
                  }
                }
              }
            }
          }
        }
      })
    },
    forceEject () {
      this.loading = true
      const param = {
        'deviceId': this.deviceId,
        'slot': this.choice
      }
      pop(param).then(result => {
        this.$message({
            message: '弹宝成功！',
            type: 'success',
            duration: 3000
          })
      })
      if (param.slot == '1') {
        this.img1 = require('../../../static/image/device/kong.png')
        this.bank1 = ''
      } else if (param.slot == '2') {
        this.img2 = require('../../../static/image/device/kong.png')
        this.bank2 = ''
      } else if (param.slot == '3') {
        this.img3 = require('../../../static/image/device/kong.png')
        this.bank3 = ''
      } else if (param.slot == '4') {
        this.img4 = require('../../../static/image/device/kong.png')
        this.bank4 = ''
      } else if (param.slot == '5') {
        this.img5 = require('../../../static/image/device/kong.png')
        this.bank5 = ''
      } else if (param.slot == '6') {
        this.img6 = require('../../../static/image/device/kong.png')
        this.bank6 = ''
      } else if (param.slot == '7') {
        this.img7 = require('../../../static/image/device/kong.png')
        this.bank7 = ''
      } else if (param.slot == '8') {
        this.img8 = require('../../../static/image/device/kong.png')
        this.bank8 = ''
      } else if (param.slot == '9') {
        this.img9 = require('../../../static/image/device/kong.png')
        this.bank9 = ''
      } else if (param.slot == '10') {
        this.img10 = require('../../../static/image/device/kong.png')
        this.bank10 = ''
      } else if (param.slot == '11') {
        this.img11 = require('../../../static/image/device/kong.png')
        this.bank11 = ''
      } else if (param.slot == '12') {
        this.img12 = require('../../../static/image/device/kong.png')
        this.bank12 = ''
      } else if (param.slot == '13') {
        this.img13 = require('../../../static/image/device/kong.png')
        this.bank13 = ''
      } else if (param.slot == '14') {
        this.img14 = require('../../../static/image/device/kong.png')
        this.bank14 = ''
      } else if (param.slot == '15') {
        this.img15 = require('../../../static/image/device/kong.png')
        this.bank15 = ''
      } else if (param.slot == '16') {
        this.img16 = require('../../../static/image/device/kong.png')
        this.bank16 = ''
      } else if (param.slot == '17') {
        this.img17 = require('../../../static/image/device/kong.png')
        this.bank17 = ''
      } else if (param.slot == '18') {
        this.img18 = require('../../../static/image/device/kong.png')
        this.bank18 = ''
      } else if (param.slot == '19') {
        this.img19 = require('../../../static/image/device/kong.png')
        this.bank19 = ''
      } else if (param.slot == '20') {
        this.img20 = require('../../../static/image/device/kong.png')
        this.bank20 = ''
      } else if (param.slot == '21') {
        this.img21 = require('../../../static/image/device/kong.png')
        this.bank21 = ''
      } else if (param.slot == '22') {
        this.img22 = require('../../../static/image/device/kong.png')
        this.bank22 = ''
      } else if (param.slot == '23') {
        this.img23 = require('../../../static/image/device/kong.png')
        this.bank23 = ''
      } else if (param.slot == '24') {
        this.img24 = require('../../../static/image/device/kong.png')
        this.bank24 = ''
      }
      this.loading = false
    },
    restartDevice () {
      this.loading = true
      restart({deviceId: this.deviceId}).then(result => {
        if (result.code === '000000') {
          this.loading = false
          this.$message({
            message: '重启成功！',
            type: 'success',
            duration: 3000
          })
        }
      })
      this.loading = true
    },
    allEjectDevice () {
      this.loading = true
      const popDeviceDtoList = []
      for (let i = 0; i < this.deviceInfo.length; i++) {
        let data = {
          'powerBoxId': this.deviceId,
          'slot': this.deviceInfo[i]['slot']
        }
        popDeviceDtoList.push(data)
      }
      let config = {
        headers: {'Content-Type': 'application/json', 'Authorization': 'zyyc_pc_mange_system'}
      }
      axios.post('/ps/deviceManagement/allEject', popDeviceDtoList, config).then(result => {
        if (result.data.code === '000000') {
          this.$message({
            message: '操作成功，系统会在5秒之后重新查询设备库存信息，请稍等！',
            type: 'success',
            duration: 3000
          })
          this.timer = setInterval(() => {
            this.times--
            if (this.times === 0) {
              this.tiems = 5
              clearInterval(this.timer)
              this.getDeviceInfo()
            }
          }, 1000)
          this.loading = false
        }
      })
    },
    cancle () {
      this.choice = ''
      let one = document.getElementById('one')
      let two = document.getElementById('two')
      let three = document.getElementById('three')
      let four = document.getElementById('four')
      let five = document.getElementById('five')
      let six = document.getElementById('six')
      let seven = document.getElementById('seven')
      let eight = document.getElementById('eight')
      let nine = document.getElementById('nine')
      one.style.border = '0px'
      two.style.border = '0'
      three.style.border = '0px'
      four.style.border = '0px'
      five.style.border = '0px'
      six.style.border = '0px'
      seven.style.border = '0px'
      eight.style.border = '0px'
      nine.style.border = '0px'
      let twelveOne = document.getElementById('twelveOne')
      let twelveTwo = document.getElementById('twelveTwo')
      let twelveThree = document.getElementById('twelveThree')
      let twelveFour = document.getElementById('twelveFour')
      let twelveFive = document.getElementById('twelveFive')
      let twelveSix = document.getElementById('twelveSix')
      let twelveSeven = document.getElementById('twelveSeven')
      let twelveEight = document.getElementById('twelveEight')
      let twelveNine = document.getElementById('twelveNine')
      let twelveTen = document.getElementById('twelveTen')
      let twelveEleven = document.getElementById('twelveEleven')
      let twelveTwelve = document.getElementById('twelveTwelve')
      twelveOne.style.border = '0px'
      twelveTwo.style.border = '0px'
      twelveThree.style.border = '0px'
      twelveFour.style.border = '0px'
      twelveFive.style.border = '0px'
      twelveSix.style.border = '0px'
      twelveSeven.style.border = '0px'
      twelveEight.style.border = '0px'
      twelveNine.style.border = '0px'
      twelveTen.style.border = '0px'
      twelveEleven.style.border = '0px'
      twelveTwelve.style.border = '0px'
      let sixOne = document.getElementById('sixOne')
      let sixTwo = document.getElementById('sixTwo')
      let sixThree = document.getElementById('sixThree')
      let sixFour = document.getElementById('sixFour')
      let sixFive = document.getElementById('sixFive')
      let sixSix = document.getElementById('sixSix')
      sixOne.style.border = '0px'
      sixTwo.style.border = '0px'
      sixThree.style.border = '0px'
      sixFour.style.border = '0px'
      sixFive.style.border = '0px'
      sixSix.style.border = '0px'
      let p24S1 = document.getElementById('p24S1')
      let p24S2 = document.getElementById('p24S2')
      let p24S3 = document.getElementById('p24S3')
      let p24S4 = document.getElementById('p24S4')
      let p24S5 = document.getElementById('p24S5')
      let p24S6 = document.getElementById('p24S6')
      let p24S7 = document.getElementById('p24S7')
      let p24S8 = document.getElementById('p24S8')
      let p24S9 = document.getElementById('p24S9')
      let p24S10 = document.getElementById('p24S10')
      let p24S11 = document.getElementById('p24S11')
      let p24S12 = document.getElementById('p24S12')
      let p24S13 = document.getElementById('p24S13')
      let p24S14 = document.getElementById('p24S14')
      let p24S15 = document.getElementById('p24S15')
      let p24S16 = document.getElementById('p24S16')
      let p24S17 = document.getElementById('p24S17')
      let p24S18 = document.getElementById('p24S18')
      let p24S19 = document.getElementById('p24S19')
      let p24S20 = document.getElementById('p24S20')
      let p24S21 = document.getElementById('p24S21')
      let p24S22 = document.getElementById('p24S22')
      let p24S23 = document.getElementById('p24S23')
      let p24S24 = document.getElementById('p24S24')
      p24S1.style.border = '0px'
      p24S2.style.border = '0px'
      p24S3.style.border = '0px'
      p24S4.style.border = '0px'
      p24S5.style.border = '0px'
      p24S6.style.border = '0px'
      p24S7.style.border = '0px'
      p24S8.style.border = '0px'
      p24S9.style.border = '0px'
      p24S10.style.border = '0px'
      p24S11.style.border = '0px'
      p24S12.style.border = '0px'
      p24S13.style.border = '0px'
      p24S14.style.border = '0px'
      p24S15.style.border = '0px'
      p24S16.style.border = '0px'
      p24S17.style.border = '0px'
      p24S18.style.border = '0px'
      p24S19.style.border = '0px'
      p24S20.style.border = '0px'
      p24S21.style.border = '0px'
      p24S22.style.border = '0px'
      p24S23.style.border = '0px'
      p24S24.style.border = '0px'
    },
    bankOrder (item) {
      this.bankOrderDialog = true
      this.$nextTick(() => {
        this.$refs.bankOrder.init(item)
      })
    }
  }
}
</script>
<style scoped>
.device {
  width: 100%;
  height: 100%;
}
.el-form {
  float: left;
  margin-left: 20px;
  margin-top: 10px;
}
.el-form-item {
    display: inline-block !important;
  }

.deviceDetail {
  width: 95%;
  height: 70%;
  margin-top: 1%;
  margin-left: 2%;
  float: left;
  border: 3px solid #81CADB;
  border-radius: 10px;
}

.erweima {
  width: 6%;
  height: 90%;
  margin: 0.5%;
  float: left;
}

.deviceState {
  margin-top: 0.5%;
  float: left;
  width: 30%;
  height: 100%;
}

.black {
  font-size: 0.4rem;
  color: #666666;
}

.chengshe {
  font-size: 0.4rem;
  color: #4691F3;
}

.operationDevice {
  width: 40%;
  height: 100%;
  margin-top: 0.5%;
  margin-right: 1%;
  float: right;
}
/deep/ .el-input__inner {
    border-radius: 10px;
  }
.xuanzhong {
  font-size: 0.4rem;
  color: #666666;
}

.slot {
  font-size: 0.4rem;
  color: #4691F3;
}

.elButton {
  width: 70%;
  float: right;
}

.qiangtan {
  width: 30%;
  height: 48%;
  font-size: 0.3rem;
  color: #FFFFFF;
  background-color: #F96A57;
}

.restart {
  width: 30%;
  height: 48%;
  font-size: 0.3rem;
  color: #FC4830;
  border: 1px solid #FC4830;
}
.allEject{
  width: 30%;
  height: 48%;
  font-size: 0.3rem;
  color: #FFFFFF;
  background-color: #F96A57;
}
.sixDevice{
  display: none;
}
.eightDevice{
  display: none;
}
.nineDevice {
  display: none;
}

.twelveDevice {
  display: none;
}

.twelveDevice .el-divider--vertical {
  display: inline-block;
  width: 1px;
  height: 8em;
  margin: 0px;
  vertical-align: middle;
  position: relative;
}

.twentyFourDevice {
  display: none;
}

.twentyFourDevice .el-divider--vertical {
  display: inline-block;
  width: 1px;
  height: 8em;
  margin: 0px;
  vertical-align: middle;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/devicemanagement/device.vue